import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO } from '../config';
import './Footer.css';

function Footer({ config }) {
  const currentYear = new Date().getFullYear();
  const hostname = window.location.hostname.replace('www.', '');
  const displayEmail = `info@${hostname}`;

  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="container">
          <div className="row g-4">
            {/* Brand Column */}
            <div className="col-lg-4 col-md-6">
              <div className="footer-brand">
                <h3>{config.name}</h3>
                <p className="tagline">{config.tagline}</p>
                <p className="footer-description">
                  A B2B product sourcing platform connecting buyers with verified industrial
                  suppliers and manufacturers across North America. Operated
                  by {CONTACT_INFO.businessName}.
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/categories">Products</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
              </ul>
            </div>

            {/* Policies */}
            <div className="col-lg-2 col-md-6">
              <h4>Policies</h4>
              <ul className="footer-links">
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/returns">Return Policy</Link></li>
                <li><Link to="/shipping">Shipping Policy</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="col-lg-4 col-md-6">
              <h4>Contact Us</h4>
              <ul className="contact-info">
                <li>
                  <i className="bi bi-building"></i>
                  <span>{CONTACT_INFO.businessName}</span>
                </li>
                <li>
                  <i className="bi bi-geo-alt"></i>
                  <span>{CONTACT_INFO.address}<br />{CONTACT_INFO.city}, {CONTACT_INFO.state} {CONTACT_INFO.zip}</span>
                </li>
                <li>
                  <i className="bi bi-telephone"></i>
                  <span>{CONTACT_INFO.phone}</span>
                </li>
                <li>
                  <i className="bi bi-envelope"></i>
                  <span>{displayEmail}</span>
                </li>
                <li>
                  <i className="bi bi-clock"></i>
                  <span>Mon - Fri: 8:00 AM - 6:00 PM EST</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="copyright">
                &copy; {currentYear} {CONTACT_INFO.businessName}. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="footer-badges">
                <span><i className="bi bi-shield-lock"></i> SSL Secured</span>
                <span><i className="bi bi-globe"></i> USA</span>
                <span><i className="bi bi-patch-check"></i> Verified Suppliers</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
